import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';

export const getAge = (dateOfBirth: DateTime) =>
    dateOfBirth && Math.floor(DateTime.utc().diff(dateOfBirth, 'years')?.years);

export const utcNow = () => DateTime.now().toUTC();
export const isoToUtc = (isoDateString: string) => DateTime.fromISO(isoDateString, { zone: 'utc' });

export const getFirstDateOfCurrentMonth = () => DateTime.utc(DateTime.utc().year, DateTime.utc().month, 1);

export const getDateOfCurrentMonth = (day: number) => DateTime.utc(DateTime.utc().year, DateTime.utc().month, day);

export const getLastOfCurrentMonth = () => DateTime.utc(DateTime.utc().year, DateTime.utc().month, 1).endOf('month');

export const toNgbDate = (dateTime: DateTime) => new NgbDate(dateTime.year, dateTime.month, dateTime.day);
export const toNgbDateFromDate = (date: Date) => new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
export const toNgbDateFromString = (date: string | null) => (date ? toNgbDate(dateTimeFromISO(date)) : null);
export const fromNgbDate = (date: NgbDate) => date && DateTime.local(date.year, date.month, date.day, { zone: 'utc' });
export const toDateFromNgbDate = (date: NgbDate) => new Date(date.year, date.month - 1, date.day);

export const isTodayUtc = (dateTime: DateTime) => {
    const today = DateTime.utc();
    return dateTime.year === today.year && dateTime.month === today.month && dateTime.day === today.day;
};

export const isYesterdayUtc = (dateTime: DateTime) => {
    const yesterday = DateTime.utc().minus({ days: 1 });
    return dateTime.year === yesterday.year && dateTime.month === yesterday.month && dateTime.day === yesterday.day;
};

export const dateTimeFromISO = (dateTime: string | null) => dateTime && DateTime.fromISO(dateTime);

export const toDateISOString = (date: Date | null) => date.toLocaleDateString('sv-SE');
export const toDateISOStringFromDateTime = (date: DateTime | null) => date.toISODate();

export const combineToUtcIso = (date: NgbDate, time: string): string => {
    if (!date || !time) return null;

    // Parse time (e.g., "14:30")
    const [hours, minutes] = time.split(':').map(Number);

    // Create DateTime in local timezone (user's intent)
    const localDateTime = DateTime.local(date.year, date.month, date.day, hours, minutes);

    // Convert to UTC and return ISO string
    return localDateTime.toUTC().toISO();
};

// For displaying back to user (UTC → local time)
export const utcIsoToLocalTime = (isoString: string): string => {
    if (!isoString) return '';
    return DateTime.fromISO(isoString, { zone: 'utc' }).toLocal().toFormat('HH:mm');
};

export const utcIsoToLocalDate = (isoString: string): string => {
    if (!isoString) return '';
    return DateTime.fromISO(isoString, { zone: 'utc' }).toLocal().toFormat('yyyy-MM-dd');
};

// export const utcIsoToNgbDate = (isoString: string): NgbDate => {
//     if (!isoString) return null;
//     const local = DateTime.fromISO(isoString, { zone: 'utc' }).toLocal();
//     return new NgbDate(local.year, local.month, local.day);
// };
